import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({ locale, type }, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/hub/${locale}/${type}/benefits.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
    },
  }),
};
